import { useEffect, useState } from "react";
import { getVolunteers } from "../../../api/apiServices";

export default function VolunteerDashboard() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const res = await getVolunteers();
      setApplications(res.data);
    } catch (error) {
      console.error("Failed to fetch volunteers", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading volunteer applications...</p>;

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">Volunteer Applications</h2>

      <table className="w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">Name</th>
            <th className="p-2 border">Email</th>
            <th className="p-2 border">Interest</th>
            <th className="p-2 border">Availability</th>
            <th className="p-2 border">Status</th>
          </tr>
        </thead>
        <tbody>
          {applications.map((app) => (
            <tr key={app._id}>
              <td className="p-2 border">{app.name}</td>
              <td className="p-2 border">{app.email}</td>
              <td className="p-2 border">{app.interest}</td>
              <td className="p-2 border">{app.availability}</td>
              <td className="p-2 border">
                <span
                  className={`px-2 py-1 rounded text-white ${
                    app.status === "approved"
                      ? "bg-green-500"
                      : app.status === "rejected"
                      ? "bg-red-500"
                      : "bg-yellow-500"
                  }`}
                >
                  {app.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
